module.exports = __webpack_public_path__ + "slick.ced611daf7709cc778da.eot";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/node_modules/slick-carousel/slick/fonts/slick.eot
// module id = ../../../../slick-carousel/slick/fonts/slick.eot
// module chunks = styles